import { userDeviceIdLocalStorageKey } from "@/lib/shared/consts/userDeviceIdKey";
import { deleteUserDevice } from "../../user-devices/api/user-device.api";

/**
 * Unregisters a device registered under the current user.
 */
export const unregisterRegisteredUserDevice = async () => {
  try {
    const userDeviceId = localStorage.getItem(userDeviceIdLocalStorageKey);
    if (userDeviceId) {
      await deleteUserDevice({
        where: {
          id: parseInt(userDeviceId),
        },
      });

      localStorage.removeItem(userDeviceId);
    }
  } catch (e) {}
};
